import { render, staticRenderFns } from "./DistributorForManager.vue?vue&type=template&id=c654ca3c"
import script from "./DistributorForManager.vue?vue&type=script&lang=js"
export * from "./DistributorForManager.vue?vue&type=script&lang=js"
import style0 from "./DistributorForManager.vue?vue&type=style&index=0&id=c654ca3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports